import React from "react";
import "./FieldViewBlock.scss";

export type FieldViewBlockProps = {
  children?: React.ReactNode;
  text?: string;
  label?: string;
  className?: string;
  "data-testid"?: string;
};

const FieldViewBlock: React.FC<FieldViewBlockProps> = ({
  children,
  label,
  text,
  className = "",
  "data-testid": dataTestId = "",
}) => {
  return (
    <div className={`field-view-wrapper ${className}`} data-testid={dataTestId}>
      <div className="field-view-label">{label}</div>
      {!!text && <div className="field-view-text">{text}</div>}
      {children}
    </div>
  );
};

export default FieldViewBlock;
